import React from "react";
//import { PagesWrapperStyled } from "./styled";
import TemplatesLibraryPage from "../pages/TemplatesLibraryPage/TemplatesLibraryPage";
import { observer, inject } from "mobx-react";
import RouterStore from "../../stores/RouterStore";
import IntegrationsPage from "../pages/IntegrationsPage/IntegrationsPage";
import ContactForm7IntegrationPage from "../pages/ContactForm7IntegrationPage/ContactForm7IntegrationPage";
import { Switch, Route, Redirect } from "react-router-dom";
import CreateTemplatePage from "../Templates/CreateTemplatePage/CreateTemplatePage";
import BuilderPage from "../Templates/BuilderPage/BuilderPage";
import ElementorIntegrationPage from "../pages/ElementorIntegrationPage/ElementorIntegrationPage";

type Props = {
  routerStore?: RouterStore;
};

@inject("routerStore")
@observer
class PagesWrapper extends React.PureComponent<Props, any> {
  render() {
    return (
      <Switch>
        <Route
          path="/templates"
          render={({ match: { url } }) => (
            <>
              <Route path={`${url}/`} component={TemplatesLibraryPage} exact />
              <Route path={`${url}/new`} component={CreateTemplatePage} />
              <Route path={`${url}/:id/edit`} component={BuilderPage} />
            </>
          )}
        />

        <Route
          path="/integration"
          render={({ match: { url } }) => (
            <>
              {/* <Route path={`${url}/`} component={TemplatesLibraryPage} exact /> */}
              <Route
                path={`${url}/plugins`}
                render={({ match: { url } }) => (
                  <>
                    <Route
                      path={`${url}/`}
                      component={IntegrationsPage}
                      exact
                    />
                    <Route
                      path={`${url}/cf7/edit`}
                      component={ContactForm7IntegrationPage}
                    />
                    <Route
                      path={`${url}/elementor/edit`}
                      component={ElementorIntegrationPage}
                    />
                  </>
                )}
              />
              <Route path={`${url}/:id/edit`} component={BuilderPage} />
            </>
          )}
        />

        <Route path="/" exact>
          <Redirect to="/templates" />
        </Route>
        <Route path="*">
          <Redirect to="/templates" />
        </Route>

        {/* <Route path="/integration/plugins">
          <IntegrationsPage />
        </Route>
        <Route path="/cf7/edit">
          <ContactForm7IntegrationPage />
        </Route> */}
      </Switch>
    );
  }
}
export default PagesWrapper;
